import { DATE_FORMAT_WITH_HOUR_MINS, displayDate } from 'utils/date';
import { RULE_TYPES } from '../constants';
import { useRuleBuilder } from '../hooks/useRuleBuilder';
import { Rule } from '../types';
import { ChildRule } from './ChildRule';
import {
  StyledBoldRuleHeader,
  StyledChildRuleContainer,
  StyledRuleBlockContainer,
  StyledRuleHeader,
} from './index.styles';

type RuleBlockProps = {
  rule: Rule;
  ruleIdx: number;
  canDelete: boolean;
  isMaxOneRule?: boolean;
  numUsersExited?: number;
};

export const ReadOnlyRuleBlock = ({
  rule,
  ruleIdx,
  numUsersExited,
  isMaxOneRule = false,
}: RuleBlockProps) => {
  const { childRules, enabledDate } = rule;
  const { state } = useRuleBuilder();
  const isArchived = enabledDate === null;
  return (
    <StyledRuleBlockContainer
      data-test="ruleblock-container"
      hasChildRules={childRules.length > 0}
      isMaxOneRule={isMaxOneRule}
    >
      {!isMaxOneRule && (
        <StyledRuleHeader>
          <span>
            <StyledBoldRuleHeader>{numUsersExited} users exited</StyledBoldRuleHeader>
          </span>
          {isArchived ? (
            <span>Archived</span>
          ) : (
            <span>Set on {displayDate(enabledDate, DATE_FORMAT_WITH_HOUR_MINS)}</span>
          )}
        </StyledRuleHeader>
      )}
      {childRules.map((childRule, childRuleIdx: number) => {
        const searchQuery = state?.rules[ruleIdx].childRules[childRuleIdx].searchQuery;
        const searchQueries = searchQuery?.searchQueries ?? [];
        const { combinator } = searchQuery;
        const isUserPropertyType = childRule.ruleType === RULE_TYPES.USER_PROPERTY;

        return (
          <div key={`r${ruleIdx}c${childRuleIdx}`}>
            <StyledChildRuleContainer
              key={childRuleIdx}
              data-test="ruleblock-child-rule"
              isMaxOneRule={false}
            >
              <ChildRule
                searchQueries={searchQueries}
                childRule={childRule}
                combinator={combinator}
                isUserPropertyType={isUserPropertyType}
                isDisabled
              />
            </StyledChildRuleContainer>
          </div>
        );
      })}
    </StyledRuleBlockContainer>
  );
};
